<template>
  <f7-page class="home-page-wrap">
    <div class="wave-header-oblique sticky-top">
      <img class="index-logo" src="../../images/logo/logo-all.png" alt />
    </div>

    <div class="list no-hairlines-md">
    
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">學號</div>
            <div class="item-input-wrap">
              <input type="text" v-model="number_id" placeholder="學號" />
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">密碼</div>
            <div class="item-input-wrap">
              <input type="password" v-model="pwd" placeholder="密碼" />
            </div>
          </div>
        </li>
      </ul>
      
      <f7-block>
        <f7-button class="button-fill" @click="login_session()">登入</f7-button>
      </f7-block>

  
      <a class="button" style="width: fit-content;margin: auto;font-size:20px" @click="transferlink()">以東海 SSO 登入</a>
    
    
    </div>
  </f7-page>
</template>

<script>
import Service from "../../service";
import axios from '../../js/axiosModule.js';
var moment = require('moment');
export default {
  data() {
    return {
      userInfo: {},
      number_id: "",
      pwd: ""
    };
  },
  methods: {
    transferlink : function () {
      location.href = "https://oauth.thu.edu.tw/v1/index.php/oauth/authorize?response_type=code&client_id=Oa6N2SZeyHvZ9WNUbkBbpowcmWsPyD";
                
    },
    login_session: function() {
      let self = this;
      if (self.number_id.length > 6 && self.pwd.length > 6 && self.number_id == self.pwd) {
        axios.axiosTokenGet(self.$app.axiosUrl + "/api/Authenticate/Login/"+self.number_id).then((response) => {
         
          return new Promise((resolve,reject) => {
              self.userInfo.studentNo = response.data.data.studentNo;
                  self.userInfo.chineseName = response.data.data.chineseName;
                  self.userInfo.position = response.data.data.position;
                  self.userInfo.department = response.data.data.department;
                  self.userInfo.mobilePhone = response.data.data.mobilePhone;
                  self.userInfo.email = response.data.data.email;
                  self.userInfo.type = response.data.data.type;
                  self.userInfo.avatarPath = response.data.data.avatarPath;
                  self.$store.dispatch("authFlagTrigger",true);
                  self.$store.dispatch("tokenTrigger",response.data.data.token);
                  self.$store.dispatch("coachTrigger",response.data.data.coachType);
                  self.$store.dispatch("userTrigger", self.userInfo);
            setTimeout(
              function() {
                self.$f7router.navigate("/");
                
                }
            ,100);
          });
        }).catch(err => function(){});
        
      } else {
        alert("請使用下方 東海 SSO 登入");
      }
      
      
      
    }
  },created() {
   console.log(moment("2019-02-17 14:23:34", "YYYY-MM-DD HH:mm:ss")._d);
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/users/log-in.vue